<template>
	<div class="super-support-container">
		<div class="row centered chat-log-container">
			<AIChatsLogs />
		</div>
		<div class="row centered shop-orders-container">
			<AppTable main-color="#6c33cb" ref="shop-orders-table"
					  :fetch-function="getShopOrders"
					  :filters="filters"
					  :table-headings="tableHeadings"
					  :title="getString('shop_orders')"
					  :total-items="shopOrdersTotal || 0"
					  :items="shopOrders || []"
					  initial-sort-field="created_at"
					  @failed-fetch="details=>{$emit('failed-fetch', details)}">

				<template #items="{item}">
					<div class="items-list">
						<div v-for="(orderItem, index) in item.items_list" :key="index" class="item-entry">
							{{ orderItem.quantity }}x {{ orderItem.name }}
						</div>
					</div>
				</template>

			</AppTable>
			<AppNotification :title="getString('error')" :body-text="getString('generic_error')" :type="-2" ref="generic-error" />
		</div>
	</div>
</template>

<script>
import AIChatsLogs from "@/user/components/super/AIChatsLogs.vue";
import AppTable from "@/shared/components/AppTable.vue";
import AppNotification from "@/shared/components/AppNotification.vue";
import API from "@/shared/helpers/API";
import {useLanguageStore} from "@/shared/stores";
import {getLocalDateFromServer, formatDateTime} from "@/shared/helpers/dates";
import {useSuperStore, useUserStore} from "@/user/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const superStore = useSuperStore();
		return {getString: languageStore.getString, languageStore, userStore, superStore};
	},
	name: "SuperSupport",
	components: {AIChatsLogs, AppTable, AppNotification},
	data() {
		return {
			shopOrdersTotal: 0,
			shopOrders: [],
			filters: [
				{
					type: "date",
					key: 'created_at',
					tableName: 'shop_orders',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "price",
					key: "amount",
					text: this.getString('amount'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
				{
					type: "exactMatch",
					key: "business_id",
					text: this.getString('business_id'),
					placeholder: this.getString('business_id'),
					active: false,
					value: null,
					finalValue: '',
				},
				{
					type: "checklist",
					key: "status",
					text: this.getString('status'),
					values: ['pending', 'completed', 'failed'],
					keysArray: ['pending', 'completed', 'failed'],
					active: false,
					selectedIndexes: [],
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'created_at',
				},
				{
					text: "Business ID",
					cols: 1,
					sortable: true,
					fieldName: 'business_id_string',
					sortFieldName: 'business_id',
				},
				{
					text: this.getString('status'),
					cols: 1,
					fieldName: 'status',
				},
				{
					text: this.getString('email'),
					cols: 2,
					fieldName: 'customer_email',
				},
				{
					text: this.getString('amount'),
					cols: 1,
					sortable: true,
					fieldName: 'amount',
				},
				{
					text: this.getString('products'),
					fieldName: 'items',
					cols: 3,
					slotName: 'items',
				},
			],
		}
	},
	methods: {
		getShopOrders(filters, callback = null) {
			API.init().getShopOrders(JSON.stringify(filters || []), r=> {
				this.shopOrders = [];
				this.shopOrdersTotal = 0;
				if(r && r.result === "OK") {
					if(r.shop_orders && r.shop_orders.selected && r.shop_orders.selected.length) {
						r.shop_orders.selected.forEach(order => {
							this.shopOrders.push(this.normalizeShopOrder(order));
						});
						this.shopOrdersTotal = Number(r.shop_orders.selected_num || 0);
					}
					if(callback) { callback(true); }
				} else {
					this.$refs["generic-error"].openNotification();
					if(callback) { callback(false, r ? r.details : null); }
				}
			});
		},
		normalizeShopOrder(order) {
			order.created_at = order.created_at ? formatDateTime(getLocalDateFromServer(order.created_at), false) : null;
			order.amount = Number(order.amount || 0);
			order.business_id_string = order.business_id ? "#"+order.business_id : "-";
			
			// Parse items JSON
			try {
				order.items_list = JSON.parse(order.items || '[]');
			} catch(e) {
				order.items_list = [];
			}
			
			return order;
		},
	}
};
</script>

<style scoped>
.super-support-container {
	width: 100%;
}
.chat-log-container {
	max-width: 1400px;
	margin: 0 auto 40px;
}
.shop-orders-container {
	max-width: 1400px;
	margin: 0 auto;
}
.items-list {
	font-size: 12px;
	line-height: 1.4;
}
.item-entry {
	margin-bottom: 2px;
}
</style>
